<div class="cell"
     [class.cell_marked]="type === CellColor.Marked"
     [class.cell_selected]="type === CellColor.Selected">
  <span class="cell__main-info" *ngIf="mainInfo">{{ mainInfo }}</span>
  <div class="cell__description">
    <ng-content></ng-content>
  </div>
</div>
